module.exports = __webpack_public_path__ + "static/media/Logo-farmageo-borde.8c5d46c6.png";